import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { getWhatsAppUrl } from '../utils/whatsapp';
export const ContactForm = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    zona: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const message = `Hola! Soy ${formData.nombre}. Mi teléfono es ${formData.telefono}. Me gustaría consultar por depilación láser en: ${formData.zona}.`;
    window.open(getWhatsAppUrl(message), '_blank');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section className="py-12 sm:py-14 bg-white" id="contacto" data-id="element-70">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-slate-50 rounded-3xl p-6 sm:p-10 border border-slate-200 shadow-sm" data-id="element-72">
          <div className="text-center mb-8" data-id="element-73">
            <h2 className="text-2xl sm:text-3xl font-bold text-navy-900 mb-3" data-id="element-74">
              Consultá sin compromiso
            </h2>
            <p className="text-slate-600" data-id="element-75">
              Dejanos tus datos y te responderemos por WhatsApp a la brevedad
              para asesorarte.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-76">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-77">
              <div data-id="element-78">
                <label htmlFor="nombre" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-79">
                  Nombre completo
                </label>
                <input type="text" id="nombre" name="nombre" required value={formData.nombre} onChange={handleChange} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all bg-white" placeholder="Ej: María Pérez" data-id="element-80" />
              </div>
              <div data-id="element-81">
                <label htmlFor="telefono" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-82">
                  Teléfono
                </label>
                <input type="tel" id="telefono" name="telefono" required value={formData.telefono} onChange={handleChange} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all bg-white" placeholder="Ej: 099 123 456" data-id="element-83" />
              </div>
            </div>

            <div data-id="element-84">
              <label htmlFor="zona" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-85">
                Zona de interés principal
              </label>
              <select id="zona" name="zona" required value={formData.zona} onChange={handleChange} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all bg-white text-slate-700" data-id="element-86">
                <option value="" disabled data-id="element-87">
                  Seleccioná una zona...
                </option>
                <optgroup label="Mujer" data-id="element-88">
                  <option value="Cuerpo completo (Mujer)" data-id="element-89">
                    Cuerpo completo
                  </option>
                  <option value="Piernas" data-id="element-90">Piernas</option>
                  <option value="Axilas" data-id="element-91">Axilas</option>
                  <option value="Zona íntima" data-id="element-92">Zona íntima</option>
                  <option value="Tira de cola" data-id="element-93">Tira de cola</option>
                  <option value="Bozo y mentón" data-id="element-94">Bozo y mentón</option>
                </optgroup>
                <optgroup label="Hombre" data-id="element-95">
                  <option value="Cuerpo completo (Hombre)" data-id="element-96">
                    Cuerpo completo
                  </option>
                  <option value="Pecho y abdomen" data-id="element-97">Pecho y abdomen</option>
                  <option value="Espalda" data-id="element-98">Espalda</option>
                  <option value="Barba" data-id="element-99">Barba</option>
                </optgroup>
                <option value="Varias zonas / Otro" data-id="element-100">Varias zonas / Otro</option>
              </select>
            </div>

            <Button type="submit" variant="primary" size="md" className="w-full mt-8 text-sm sm:text-base" data-id="element-101">
              Enviar consulta por WhatsApp
            </Button>

            <p className="text-xs text-center text-slate-500 mt-4" data-id="element-102">
              Al hacer clic, se abrirá WhatsApp con un mensaje prearmado. No
              guardamos tus datos.
            </p>
          </form>
        </motion.div>
      </div>
    </section>;
};